<template>
	<div>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<!-- HEADER -->
				<wrapper-mobile-view>
					<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
						<div class="w-100">
							<div class="row">
								<div class="col-1 align-self-center">
									<router-link :to="`/${getMerchant.code}/upselling/booking-result/${trx_order_id}`" class="d-inline-grid">
                    <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
                  </router-link>
								</div>
								<div class="col-9 align-self-center">
									<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.complete-data')}}</p>
								</div>
							</div>
						</div>
					</div>
				</wrapper-mobile-view>
				<block :height="57" />
				<div class="px-4 pb-4">
					<div class="w-100">
						<div class="row">
							<div class="col-6">
								<p class="body-3-3-1 mb-0">{{$t('hotel.concierge.invoice')}}</p>
								<p class="body-2-1 mb-0">{{original_data.invoice}}</p>
							</div>
							<div class="col-6">
								<p class="body-3-3-1 mb-0">{{$t('hotel.success.transaction-date')}}</p>
								<p class="body-2-1 mb-0">{{$formatDateTime(original_data.created_at)}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="p-4 bg-light-page border-t-semi-grey">
					<div class="w-100">
						<div class="row">
							<div class="col-12">
								<!-- <p class="body-3-3-1 mb-1">Booked Voucher</p> -->
								<div class="w-100">
									<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.booked-voucher')}}</p>
									<p class="body-3 mb-3 w-100">{{$t('hotel.concierge.fitur.click-to-change-data-or-view-details')}}</p>
  								<div class="w-100 p-3 bg-white radius-6 light-card-shadow mb-3 pb-3 border-semi-grey" v-for="(voucher,index) in trx.tx_detail_list" :class="{'mb-3': index+1 < trx.tx_detail_list.length}">
  									<div class="pb-2 mb-2 border-b-semi-grey-dashed">
  										<div class="row no-gutters cursor-pointer">
  											<div class="col-10">
													<p class="sub-heading-1-1 mb-0" @click="toggleDetailForm(voucher)">{{voucher.product_name}}</p>
													<p class="body-2-2-1 mb-0">{{voucher.product_category_name}}</p>
  											</div>
  											<div class="col-2 text-center">
  												<p class="sub-heading-1-2 mb-0 text-green">{{voucher.qty}}</p>
  												<span class="body-3 mb-0">{{$pluralWord(voucher.qty,'Voucher')}}</span>
  											</div>
  										</div>
  									</div>
  									<div class="w-100">
  										<!-- SERVICE DATE -->
  										<div v-if="voucher.product_category_code != 'other'" class="row no-gutters mb-3">
  											<div class="col-1 pt-2">
  												<i class="simple-icon-calendar text-semi-dark text-18"></i>
  											</div>
  											<div class="col-11" @click="toggleDetailForm(voucher)">
  												<div class="pl-2">
	  												<span class="body-3 mb-0 w-100">{{$t('hotel.concierge.fitur.service-date')}}</span>
	  												<p v-if="!compareDate(voucher.service_date,voucher.created_at)" class="body-2-1 mb-0 w-100">{{voucher.product_category_code != 'experience' ? $formatDateTime(voucher.service_date) : $formatDate(voucher.service_date)}}</p>
	  												<p v-else class="body-3-1 mb-0 w-100 font-italic text-danger cursor-pointer text-underline-dashed">{{$t('hotel.concierge.fitur.choose-service-date')}}</p>
	  											</div>
  											</div>
  										</div>

  										<template v-if="voucher.product_category_code == 'transport'">
  											<template v-if="voucher.product_custom_data != null && voucher.product_custom_data.is_airport_pickup">
  												<div class="row no-gutters mb-3">
		  											<div class="col-1 pt-2">
		  												<i class="simple-icon-plane text-semi-dark text-18"></i>
		  											</div>
		  											<div class="col-11" @click="toggleDetailForm(voucher)">
		  												<div class="pl-2">
			  												<span class="body-3 mb-0 w-100">{{$t('hotel.concierge.fitur.upselling.flight-number')}}</span>
			  												<p v-if="parsingRemark(voucher.remark, 'Flight Number') != ''" class="body-2-1 mb-0 w-100">{{parsingRemark(voucher.remark, 'Flight Number')}}</p>
			  												<p v-else class="body-3-1 mb-0 w-100 font-italic text-danger cursor-pointer text-underline-dashed">{{$t('hotel.concierge.fitur.choose-service-date')}}</p>
			  											</div>
		  											</div>
		  										</div>
		  										<div class="row no-gutters mb-3">
		  											<div class="col-1 pt-2">
		  												<i class="simple-icon-directions text-semi-dark text-18"></i>
		  											</div>
		  											<div class="col-11" @click="toggleDetailForm(voucher)">
		  												<div class="pl-2">
			  												<span class="body-3 mb-0 w-100">{{$t('hotel.concierge.fitur.upselling.terminal')}}</span>
			  												<p v-if="parsingRemark(voucher.remark, 'Terminal') != ''" class="body-2-1 mb-0 w-100">{{parsingRemark(voucher.remark, 'Terminal')}}</p>
			  												<p v-else class="body-3-1 mb-0 w-100 font-italic text-danger cursor-pointer text-underline-dashed">{{$t('hotel.concierge.fitur.upselling.fill-data')}}</p>
			  											</div>
		  											</div>
		  										</div>
  											</template>
  											<div class="row no-gutters mb-3">
		  											<div class="col-1 pt-2">
		  												<i class="simple-icon-location-pin text-semi-dark text-18"></i>
		  											</div>
		  											<div class="col-11" @click="toggleDetailForm(voucher)">
		  												<div class="pl-2">
			  												<span class="body-3 mb-0 w-100">{{voucher.product_custom_data != null && voucher.product_custom_data.is_airport_pickup ? 'Drop area' : 'Pickup/Drop area'}}</span>
			  												<p v-if="parsingRemark(voucher.remark, 'Pickup Drop Area') != ''" class="body-2-1 mb-0 w-100">{{parsingRemark(voucher.remark, 'Pickup Drop Area')}}</p>
			  												<p v-else class="body-3-1 mb-0 w-100 font-italic text-danger cursor-pointer text-underline-dashed">{{$t('hotel.concierge.fitur.upselling.fill-data')}}</p>
			  											</div>
		  											</div>
		  										</div>
  										</template>

  										<!-- GENDER & PLACE -->
  										<template v-if="voucher.product_category_code == 'spa'">
  											<div class="row no-gutters mb-3">
	  											<div class="col-1 pt-2">
	  												<i class="simple-icon-heart text-semi-dark text-18"></i>
	  											</div>
	  											<div class="col-11" @click="toggleDetailForm(voucher)">
	  												<div class="pl-2">
		  												<span class="body-3 mb-0 w-100">{{$t('hotel.concierge.preferred-gender-of-therapist')}}</span>
		  												<p v-if="parsingRemark(voucher.remark, 'Gender') == ''" class="body-3-1 mb-0 w-100 font-italic text-danger text-underline-dashed cursor-pointer">{{$t('hotel.concierge.fitur.upselling.fill-data')}}</p>
	  													<p v-else class="body-2-1 mb-0 w-100">{{$capitalize(parsingRemark(voucher.remark, 'Gender'))}}</p>
		  											</div>
	  											</div>
	  										</div>
	  										<div class="row no-gutters mb-3">
	  											<div class="col-1 pt-2">
	  												<i class="simple-icon-location-pin text-semi-dark text-18"></i>
	  											</div>
	  											<div class="col-11" @click="toggleDetailForm(voucher)">
	  												<div class="pl-2">
		  												<span class="body-3 mb-0 w-100">{{$t('general.place')}}</span>
		  												<p v-if="parsingRemark(voucher.remark, 'Place') == ''" class="body-3-1 mb-0 w-100 font-italic text-danger text-underline-dashed cursor-pointer">{{$t('hotel.concierge.fitur.upselling.fill-data')}}</p>
	  													<p v-else class="body-2-1 mb-0 w-100">{{parsingRemark(voucher.remark, 'Place')}}</p>
		  											</div>
	  											</div>
	  										</div>
  										</template>

  										<!-- NOTES -->
  										<div class="row no-gutters">
  											<div class="col-1 pt-2">
  												<i class="simple-icon-note text-semi-dark text-18"></i>
  											</div>
  											<div class="col-11" @click="toggleDetailForm(voucher)">
  												<div class="pl-2">
	  												<span class="body-3 mb-0 w-100">{{$t('hotel.concierge.fitur.notes')}}</span>
	  												<p v-if="voucher.notes == ''" class="body-2 mb-0 w-100 font-italic">{{$t('hotel.concierge.fitur.upselling.no-special-notes')}}</p>
	  												<p class="body-2-1 mb-0 w-100">{{voucher.notes}}</p>
	  											</div>
  											</div>
  										</div>
  										<!-- <button class="ga-btn-primary-outline d-table ml-auto" @click="toggleDetailForm(voucher)">{{voucher.product_category_code == 'other' ? 'Add Note':'Fill Data'}}</button> -->
  									</div>
  								</div>
  							</div>
							</div>
						</div>
					</div>
				</div>
				<div class="p-4">
					<div class="w-100">
						<div class="row">
							<div class="col-12" v-if="is_form_data_complete">
								<button class="ga-btn-primary-outline-lg" @click="backToResultPage">{{$t('hotel.concierge.fitur.upselling.my-data-is-complete')}}</button>
							</div>
  					</div>
  				</div>
				</div>

				<popup-detail
					direction="bottom" 
		    	:show="detail.show"
		    	:use_max_size="true"
		    	wrapper_size="mobile"
		    	:use_footer="true"
		    	@close="toggleDetailForm">
		    	<template v-slot:body>
		    		<template v-if="detail.show">
			    		<div class="w-100 mb-4 position-relative" style="height:180px;">
			    			<img :src="detail.data.product_image" :alt="detail.data.product_name" class="img-fit radius-12-t">
			    			<div class="bg-white rounded-circle position-absolute border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetailForm()">
									<img src="../../../assets/img/icon/close.png" alt="icon-close" width="14" />
								</div>
			    		</div>
			    		<div class="px-4">
			    			<div class="mb-4">
				    			<div class="row no-gutters cursor-pointer">
										<div class="col-8">
											<p class="sub-heading-1-1 mb-0 text-green">{{detail.data.product_name}}</p>
											<p class="body-2-2-1 mb-0">{{detail.data.product_category_name}}</p>
										</div>
										<div class="col-4 text-center">
											<div class="w-100 py-2 border-orange radius-6 cursor-pointer" @click="detail.show_information_tab = !detail.show_information_tab">
												<!-- <i class="simple-icon-info text-green text-20"></i> -->
												<p class="body-2-1 mb-0 text-orange">{{!detail.show_information_tab ? 'Information' : 'Form'}}</p>
											</div>
										</div>
									</div>
								</div>

				        <!-- FORM -->
			    			<div class="light-card-shadow p-3 border-semi-grey radius-12 mb-3" 
			    				v-if="!detail.show_information_tab">
			    				<div class="row slim-grid-row">
			    					<div class="col-12 mb-4">
			    						<div class="w-100 pb-3 border-b-semi-grey-dashed">
				    						<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.upselling.complete-the-data')}}</p>
												<p class="body-3 mb-0 w-100">{{$t('hotel.concierge.fitur.upselling.please-complete-the-data')}}</p>
											</div>
			    					</div>
			    					<template v-if="detail.form.category != 'other'">
			    						<!-- SERVICE DATE -->
				    					<div class="mb-4" :class="detail.form.time_service ? 'col-6' : 'col-12'">
				    						<!-- :available-dates="detail.other_form_data.date_avlb" -->
				    						<v-date-picker
				    							:available-dates="detail.other_form_data.date_avlb"
				    							v-model="detail.form.datetime_service"
				    							mode="date"
									        @input="changeSomeFormData('date')">
									        <div class="w-100">
								            <span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.service-date')}}</span>
								            <div class="w-100 position-relative">
								            	<div :key="detail.key" class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding">
									            	{{$formatDateWithoutMonth(detail.form.datetime_service)}}
									            </div>
									            <i class="simple-icon-calendar text-semi-dark text-16 position-absolute icon-form-position"></i>
							    					</div>
								          </div>
									      </v-date-picker>
				    					</div>

				    					<!-- SERVICE TIME -->
				    					<div class="col-6 mb-4" v-if="detail.form.time_service">
				    						<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.upselling.service-time')}}</span>
					    					<div class="w-100 position-relative">
					    						<input
					    							type="time"
							              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
							              v-model="detail.form.time_service" />
							            <i class="simple-icon-clock text-semi-dark text-16 position-absolute icon-form-position"></i>
					    					</div>
				    					</div>

				    					<!-- TRANSPORT -->
				    					<template v-if="detail.form.category == 'transport'">
				    						<template v-if="detail.data.product_custom_data != null && detail.data.product_custom_data.is_airport_pickup">
						    					<div class="col-4 mb-4">
						    						<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.upselling.flight-number')}}</span>
							    					<div class="w-100 position-relative">
							    						<input
							    							type="text"
									              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
									              v-model="detail.form.flight_number" />
									            <i class="simple-icon-plane text-semi-dark text-16 position-absolute icon-form-position"></i>
							    					</div>
						    					</div>
						    					<div class="col-8 mb-4">
						    						<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.upselling.terminal')}}</span>
							    					<div class="w-100 position-relative">
							    						<input
							    							type="text"
									              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
									              v-model="detail.form.terminal" />
									            <i class="simple-icon-directions text-semi-dark text-16 position-absolute icon-form-position"></i>
							    					</div>
						    					</div>
					    					</template>
					    					<div class="col-12 mb-4">
					    						<span class="body-3 mb-1 d-block w-100">{{detail.data.product_custom_data != null && detail.data.product_custom_data.is_airport_pickup ? 'Drop area' : 'Pickup/drop area'}}</span>
					    						<div class="w-100 position-relative">
						    						<textarea
								              rows="1"
								              placeholder="Add some special request"
								              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
								              v-model="detail.form.pickup_drop_area">
								            </textarea>
								            <i class="simple-icon-location-pin text-semi-dark text-16 position-absolute icon-form-position"></i>
						    					</div>
					    					</div>
					    				</template>

				    					<template v-if="detail.form.category == 'spa'">
				    						<!-- GENDER -->
				    						<div class="col-12 mb-4">
				    							<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.preferred-gender-of-therapist')}}</span>
				    							<div class="row slim-grid-row" :key="detail.key">
				    								<div class="col-4" v-for="(gender,index) in detail.other_form_data.gender_option">
				    									<div class="w-100 position-relative">
					          						<div 
					          							@click="changeSomeFormData('gender',gender)"
					    										class="w-100 radius-6 body-2-1" 
					    										:class="gender == detail.form.gender_therapist_selected ? 'border-green input-custom-padding text-green':'border-semi-grey cursor-pointer input-custom-padding-equal text-center'">
							          					{{$capitalize(gender)}}
					    									</div>
						          					<i v-if="gender == detail.form.gender_therapist_selected" class="simple-icon-check text-green text-16 position-absolute icon-form-position"></i>
						          				</div>
				    								</div>
				    							</div>
				    						</div>

				    						<!-- PLACE -->
				    						<div class="col-12 mb-4">
				    							<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.upselling.service-place')}}</span>
				    							<div class="row slim-grid-row" :key="detail.key">
				    								<div class="col-6" v-for="(place,index) in detail.other_form_data.place_option" :class="{'mb-3': index+2 < detail.other_form_data.place_option.length}">
				    									<div class="w-100 position-relative">
					          						<div 
					          							@click="changeSomeFormData('place',place)"
					    										class="w-100 radius-6 body-2-1" 
					    										:class="place == detail.form.place_selected ? 'border-green input-custom-padding text-green':'border-semi-grey cursor-pointer input-custom-padding-equal text-center'">
							          					{{place}}
					    									</div>
						          					<i v-if="place == detail.form.place_selected" class="simple-icon-check text-green text-16 position-absolute icon-form-position"></i>
						          				</div>
				    								</div>
				    							</div>
				    						</div>
				    					</template>
			    					</template>
			    				</div>
			    				<div class="w-100">
			    					<span class="body-3 mb-1 d-block w-100">{{$t('hotel.concierge.fitur.notes')}}</span>
			    					<div class="w-100 position-relative">
			    						<textarea
					              rows="1"
					              placeholder="Add some special request"
					              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
					              v-model="detail.form.notes">
					            </textarea>
					            <i class="simple-icon-notebook text-semi-dark text-16 position-absolute icon-form-position"></i>
			    					</div>
			    				</div>
			    			</div>

			    			<!-- INFORMATION -->
				    		<template v-if="detail.show_information_tab">
				    			<div v-if="!(detail.data.product.description == null || detail.data.product.description == '')" class="html-desc body-2-2-1 mb-3" v-html="detail.data.product.description">
									</div>
				    			<template v-for="(info,index) in detail.information">
										<div v-if="!(info.value == null || info.value == '')" class="rounded-6 mb-3 border bold-shadow px-3">
											<div class="row" data-toggle="collapse" data-target="#what_you_get" aria-expanded="false" aria-controls="what_you_get">
												<div @click="toggleDetailInfo(index)" class="col-10 py-3 align-self-center cursor-pointer">
													<p class="mb-0 body-1-2">{{info.title}}</p>
												</div>
												<div @click="toggleDetailInfo(index)" class="col-2 text-right align-self-center cursor-pointer">
													<i class="font-weight-bold text-18" :class="info.show ? 'iconsmind-Arrow-Up' : 'iconsmind-Arrow-Down'" ></i>
												</div>
												<transition name="list">
													<div class="col-12" style="overflow: hidden;" :class="info.show ? 'show-collapse' : 'hide-collapse'">
														<div class="w-100 border-top-dashed py-3">
															<div class="html-desc body-2-2-1" v-html="info.value"></div>
														</div>
													</div>
												</transition>
											</div>
										</div>
									</template>
				    		</template>
			    		</div>
			    	</template>
		    	</template>
		    	<template v-slot:footer>
		    		<div class="px-4 pt-3">
		    			<state-button :data="detail.data" :click="updateDataVoucher" variant="primary" use_notif block size="lg">{{$t('general.save')}}</state-button>
		    		</div>
		    	</template>
				</popup-detail>
      </template>
    </template>
	</div>
</template>
<script>
	import {get,put} from '@/services/index.js'
	import {mapGetters} from 'vuex'
	import moment from 'moment'

	export default{
		data(){
			return{
				is_load: true,
				error: '',
				original_data: {},
				trx: {},
				payment: {},
				detail:{
					show: false,
					data: null,
					form: {},
					key: 0,
					other_form_data:{
						gender_option: ['RANDOM','MALE','FEMALE'],
						place_option: [],
						is_airport_pickup: false,
						date_avlb:{}
					},
					show_information_tab: false,
					tab_key: 0,
					information: []
				}
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			trx_order_id(){
				return this.$route.params.tx_order_id
			},
			is_form_data_complete(){
				if(!this.trx.id){
					return false
				}else{
					let checker = true
					for(let vc of this.trx.tx_detail_list){
						if(vc.product_category_code != 'other'){
							if(moment(vc.service_date).isSame(vc.created_at)){
								checker = false
								break;
							}
							if(vc.product_category_code == 'spa'){
								if(this.parsingRemark(vc.remark,'Gender') == '' || this.parsingRemark(vc.remark,'Place') == ''){
									checker = false
									break;		
								}
							}
						}
					}
					return checker
				}
			}
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			loadDetailTrx(){
				return new Promise((success,fail)=>{
					get('CORE_HOTEL',`merchant-pos/multiple/transaction/${this.trx_order_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{	
							fail(res.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.loadDetailTrx()
				.then(response=>{
					this.original_data = response
					this.trx = response.tx_order_list[0]
					this.payment = response.tx_bill_list[0]
					this.trx.tx_detail_list.forEach((voucher,index)=>{
						this.trx.tx_detail_list[index].product_custom_data = this.trx.tx_detail_list[index].product_custom_data != null ? JSON.parse(this.trx.tx_detail_list[index].product_custom_data) : null
					})
				})
				.catch(error=>this.error = error)
				.finally(()=>this.is_load = false)
			},
			parsingRemark(data,index){
      	let split_1 = data.split(", ")
      	let callback = ''
      	for (let split_1_1 of split_1){
      		let split_2 = split_1_1.split(": ")
      		if(split_2[0] == index){
      			callback = split_2[1]
      		}
      	}
      	return callback
      },
      toggleDetailInfo(index){
				this.detail.information[index].show = !this.detail.information[index].show
			},
			toggleDetailForm(data=null){
				this.detail.show = !this.detail.show
				this.detail.data = data
				this.detail.form = {}
				this.detail.show_information_tab = false
				if(data != null){
					this.detail.information = [
						{
							value: data.product.what_you_get,
							title: 'What you get',
							show: true
						},
						{
							value: data.product.fine_print,
							title: 'Fine print',
							show: false
						},
						{
							value: data.product.how_to_redeem,
							title: 'How to redeem',
							show: false
						},
						{
							value: data.product.cancellation_policy,
							title: 'Cancellation policy',
							show: false
						}
					]
					this.detail.form.notes = data.notes
					this.detail.form.category = data.product_category_code
					if(data.product_category_code != 'other'){
						this.detail.other_form_data.date_avlb = {
							start: moment().toDate(),
							end: null
						}
						this.detail.form.datetime_service = moment(moment().format()).isAfter(moment(data.service_date).format()) ? moment().toDate() : moment(data.service_date).toDate()
						if(data.product_category_code != 'experience'){
							this.detail.form.time_service = moment.parseZone(data.service_date).utc().format("HH:mm")
						}else{
							if(data.product.min_booking_window != null){
								let avlb_date = moment(moment().add(data.product.min_booking_window-1,'d')).toDate()
								this.detail.other_form_data.date_avlb.start = avlb_date
								this.detail.form.datetime_service = moment(moment(avlb_date).format()).isAfter(moment(data.service_date).format()) ? moment(avlb_date).toDate() : moment(data.service_date).toDate()
							}
							if(data.product.max_booking_window != null){
								this.detail.other_form_data.date_avlb.end = moment(moment().add(data.product.max_booking_window,'d')).toDate()	
							}else{
								this.detail.other_form_data.date_avlb.end = null
							}
						}
					}
					if(data.product_category_code == 'transport'){
						if(data.product_custom_data != null && data.product_custom_data.is_airport_pickup){
							this.detail.form.flight_number = this.parsingRemark(data.remark,"Flight Number")
							this.detail.form.terminal = this.parsingRemark(data.remark,"Terminal")
						}
						this.detail.form.pickup_drop_area = this.parsingRemark(data.remark,"Pickup Drop Area")
					}
					if(data.product_category_code == 'spa'){
						this.detail.other_form_data.place_option = data.product_custom_data != null ? data.product_custom_data.place_option : null
						this.detail.form.gender_therapist_selected = this.parsingRemark(data.remark,"Gender")
						this.detail.form.place_selected = this.parsingRemark(data.remark,"Place")
					}
				}
			},
			updateDataVoucher(data){
				return new Promise((success,fail)=>{
					let form_data = {
						id: this.detail.data.id,
						notes: this.detail.form.notes
					}
					if(this.detail.form.category != 'other'){
						let time_service = this.detail.form.category == 'experience' ? '00:00:00' : `${this.detail.form.time_service}:00`
						form_data.datetime_service = `${moment(this.detail.form.datetime_service).format("DD-MM-YYYY")} ${time_service}`

						if(this.detail.form.category == 'spa'){
							form_data.gender_therapist_selected = this.detail.form.gender_therapist_selected
							form_data.place_selected = this.detail.form.place_selected
						}
						if(this.detail.form.category == 'transport'){
							if(this.detail.data.product_custom_data != null && this.detail.data.product_custom_data.is_airport_pickup){
								form_data.flight_number = this.detail.form.flight_number
								form_data.terminal = this.detail.form.terminal
							}
							form_data.pickup_drop_area = this.detail.form.pickup_drop_area
							form_data.total_passengers = 1
						}
					}
					let params = {
						id: this.trx_order_id,
						merchant_id: this.getMerchant.id,
						tx_order_list: [
							{
								id: this.original_data.tx_order_list[0].id,
								tx_detail_list: [form_data]
							}
						]
					}

					put("CORE_HOTEL",`merchant-pos/multiple/transaction/${this.trx_order_id}/update`,params).then(response=>{
						let res = response.data
						if(res.success){
							this.toggleDetailForm()
							this.loadFirstData()
							success(res.message)
						}else{
							fail(res.message)
						}
					})
				})
			},
			changeSomeFormData(type,data){
				if(type == 'gender'){
					this.detail.form.gender_therapist_selected = data
				}else if(type == 'place'){
					this.detail.form.place_selected = data
				}
				this.detail.key++
			},
			formatTimeUTC(date){
				return moment.parseZone(date).utc().format("H:mm a")
			},
			compareDate(date_1,date_2){
				return moment(date_1).isSame(date_2)
			},
			backToResultPage(){
				this.$router.push(`/${this.getMerchant.code}/upselling/booking-result/${this.trx_order_id}`)
			}
		}
	}
</script>
<style type="text/css">
	.tab-detail-active{
		background-color: rgb(233, 255, 227);
	}
	.hide-collapse{
		height: 0px !important;
	}
	.show-collapse{
		height: auto !important;
	}
	.input-custom-padding{
		padding: 8px 8px 8px 42px;
	}
	.input-custom-padding-equal{
		padding: 8px;
	}
	.icon-form-position{
		top: 11px;
		left: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/upselling/GroupVoucherFormData.vue